module.exports = __webpack_public_path__ + "media/images/flags/64/Grenada-1671fb437b86843900a65f53d3d984c5.png";